/**
 * Number of sales-tax states that count as REVIEWED for the store editor's
 * Tax & Legal tile: the distributor's list, but only once the Owner confirmed
 * it (Bug Intake #502). Signup auto-adds the company state, so a non-empty
 * list alone is not a finished step. Mirrors the API's
 * `launch_gates.nexus_reviewed` (non-empty AND confirmed).
 *
 * @param {object|null} dist  The campaign's distributor ({ nexus_states }).
 * @param {boolean} confirmed Whether nexus_confirmed_at is set (from
 *                            GET /distributor/nexusConfirmation/<id>).
 * @returns {number}
 */
export function reviewedNexusCount(dist, confirmed) {
    const states = dist && dist.nexus_states;
    if (!confirmed || !Array.isArray(states)) return 0;
    return states.length;
}

/**
 * The distributor id to look the confirmation up with: the campaign's
 * distributor object, else its `distributor_id`, else the signed-in account's.
 * Without a fallback a payload that omits the id would leave the Tax & Legal
 * tile "not done" with no sign why.
 */
export function nexusDistributorId(campaign, accountDistributorId) {
    return (
        campaign?.distributor?.id ??
        campaign?.distributor_id ??
        accountDistributorId ??
        null
    );
}
